import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Zap, ArrowRight, Scissors } from 'lucide-react';
import { API } from '../App';

export default function ClipPage() {
  const { shareToken } = useParams();
  const [clip, setClip] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get(`/api/clips/${shareToken}`).then(r => setClip(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [shareToken]);

  if (loading) return <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center"><div className="w-6 h-6 border-2 border-[#FF4D00] border-t-transparent rounded-full animate-spin" /></div>;

  if (!clip) return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center px-6">
      <div className="text-center"><Scissors className="w-10 h-10 text-[#2A2A2A] mx-auto mb-4" /><h1 className="text-xl font-bold font-['Barlow_Condensed'] mb-2">Clip Not Found</h1><Link to="/" className="px-6 py-2 bg-[#FF4D00] text-black text-sm font-medium inline-block mt-4">Go to Fray</Link></div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center px-6">
      <div className="max-w-2xl w-full">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <div className="w-6 h-6 bg-[#FF4D00] flex items-center justify-center" style={{ clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)' }}><Zap className="w-3.5 h-3.5 text-black" /></div>
          <span className="text-sm font-semibold font-['Barlow_Condensed']">Fray</span>
          <Scissors className="w-3.5 h-3.5 text-[#A0A0A0] ml-2" />
          <span className="text-xs text-[#A0A0A0] font-mono">CLIP</span>
        </Link>

        <div className="p-6 bg-[#1A1A1A] border border-[#2A2A2A]">
          {clip.voice && <span className="text-xs font-medium font-['Barlow_Condensed'] text-[#FF4D00] block mb-2">{clip.voice}</span>}
          {clip.phase && <span className="text-[9px] font-mono text-[#A0A0A0] block mb-3">Phase {clip.phase}</span>}
          <p className="text-sm text-[#F5F5F5] leading-relaxed whitespace-pre-wrap">{clip.text}</p>
        </div>

        <div className="text-center mt-8">
          <Link to="/signup" className="inline-flex items-center gap-2 px-6 py-2 bg-[#FF4D00] text-black font-medium text-sm">
            Run Your Own Fray <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  );
}
